import { Mui } from "@osu/react-ui";

const resetStyles = {
  border: 'none',
  marginRight: 0,
  marginLeft: 0,
  padding: 0
}

function Fieldset(props = {}) {
  const {
    legend: _legend,
    description: _description,
    children,
    sx,
    ...rest
  } = props;

  let legend, description
  if(_legend && _description) {
    legend = _legend
    description = _description
  } else if(_legend) {
    legend = _legend
  } else if(_description) {
    legend = _description
  }
  
  return (
    <Mui.Box component="fieldset" sx={[resetStyles, sx]} {...rest}>
      {legend && <Mui.Typography component="legend" variant="body1">{legend}</Mui.Typography>}
      {description && <Mui.Typography variant="body2">{description}</Mui.Typography>}
      {children}
    </Mui.Box>
  );
}

export default Fieldset;
